import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-443e2f82"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["d", "stroke", "stroke-width", "stroke-dasharray", "marker-start", "marker-end"]

import { computed } from 'vue'
import type { PPTLineElement } from '@/types/slides'
import { getLineElementPath } from '@/utils/element'
import useElementShadow from '@/views/components/element/hooks/useElementShadow'

import LinePointMarker from './LinePointMarker.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLineElement',
  props: {
    elementInfo: {}
  },
  setup(__props: any) {

const props = __props

const shadow = computed(() => props.elementInfo.shadow)
const { shadowStyle } = useElementShadow(shadow)

const svgWidth = computed(() => {
  const width = Math.abs(props.elementInfo.start[0] - props.elementInfo.end[0])
  return width < 24 ? 24 : width
})
const svgHeight = computed(() => {
  const height = Math.abs(props.elementInfo.start[1] - props.elementInfo.end[1])
  return height < 24 ? 24 : height
})

const lineDashArray = computed(() => {
  if (props.elementInfo.style !== 'dashed') return '0 0'
  const size = props.elementInfo.width
  return size <= 8 ? `${size * 5} ${size * 2.5}` : `${size * 5} ${size * 1.5}`
})

const path = computed(() => {
  return getLineElementPath(props.elementInfo)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-line",
    style: _normalizeStyle({
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "element-content",
      style: _normalizeStyle({ filter: _unref(shadowStyle) ? `drop-shadow(${_unref(shadowStyle)})` : '' })
    }, [
      (_openBlock(), _createElementBlock("svg", {
        overflow: "visible",
        width: svgWidth.value,
        height: svgHeight.value
      }, [
        _createElementVNode("defs", null, [
          (_ctx.elementInfo.points[0])
            ? (_openBlock(), _createBlock(LinePointMarker, {
                key: 0,
                id: _ctx.elementInfo.id,
                position: "start",
                type: _ctx.elementInfo.points[0],
                color: _ctx.elementInfo.color,
                baseSize: _ctx.elementInfo.width
              }, null, 8, ["id", "type", "color", "baseSize"]))
            : _createCommentVNode("", true),
          (_ctx.elementInfo.points[1])
            ? (_openBlock(), _createBlock(LinePointMarker, {
                key: 1,
                id: _ctx.elementInfo.id,
                position: "end",
                type: _ctx.elementInfo.points[1],
                color: _ctx.elementInfo.color,
                baseSize: _ctx.elementInfo.width
              }, null, 8, ["id", "type", "color", "baseSize"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("path", {
          d: path.value,
          stroke: _ctx.elementInfo.color,
          "stroke-width": _ctx.elementInfo.width,
          "stroke-dasharray": lineDashArray.value,
          fill: "none",
          "marker-start": _ctx.elementInfo.points[0] ? `url(#${_ctx.elementInfo.id}-${_ctx.elementInfo.points[0]}-start)` : '',
          "marker-end": _ctx.elementInfo.points[1] ? `url(#${_ctx.elementInfo.id}-${_ctx.elementInfo.points[1]}-end)` : ''
        }, null, 8, _hoisted_2)
      ], 8, _hoisted_1))
    ], 4)
  ], 4))
}
}

})